import React from "react";
import { connect } from "react-redux";

import About from "../../common/About/About";
import Context from "../../../context/Context";
import Directions from "../Directions/Directions";
import Events from "../Events/Events";
import Explore from "../Explore/Explore";
import ExploreCIM from "../ExploreCIM/ExploreCIM";
import MyPlaces from "../MyPlaces/MyPlaces";
import Rdx from "../../../redux/Rdx";
import SidebarButton from "./SidebarButton";
import SidebarButton2 from "./SidebarButton2";
import SidebarPanel from "./SidebarPanel";
import Topic from "../../../context/Topic";
import * as component from "../../util/component";

const CSS = {
  main: "i-sidebar",
  sidebarMenus: "i-sidebar-menus",
  sidebarMenu: "i-sidebar-menu",
  sidebarMenu2: "i-sidebar-menu2",
  sidebarButton2: "i-sidebar-button2",
  sidebarPanels: "i-sidebar-panels",
  sidebarPanelsVisible: "i-sidebar-panels-visible",
  sidebarPanelOpen: "i-sidebar-panel-open",
  expanded: "i-expanded"
};

class Sidebar extends React.Component {

  constructor(props) {
    super(props);
    this.state = component.newState({});
    this.showAbout = this.showAbout.bind(this);
  }

  componentDidMount() {
    component.own(this,[

      Topic.subscribe(Topic.DirectionsClicked,params => {
        try {
          if (Context.getInstance().config.networkServiceUrl) {
            Rdx.setValue(this,Rdx.Keys.SIDEBAR_ACTIVE_KEY,"directions");
            document.body.classList.add(CSS.sidebarPanelOpen);
            Topic.publish(Topic.SidebarButtonClicked,{sidebarKey: "directions"});
          }
        } catch(ex) {
          console.warn("Error Sidebar - Topic.DirectionsClicked");
          console.error(ex);
        }
      }),

      Topic.subscribe(Topic.ReloadViews,params => {
        try {
          Rdx.setValue(this,Rdx.Keys.SIDEBAR_ACTIVE_KEY,null);
          Rdx.setValue(this,Rdx.Keys.SIDEBAR_PANELS_EXPANDED,false);
          document.body.classList.remove(CSS.sidebarPanelOpen);
        } catch(ex) {
          console.error(ex);
        }
      })

    ]);
  }

  componentWillUnmount() {;
    component.componentWillUnmount(this);
  }

  render() {
    const i18n = Context.getInstance().i18n;

    let panelsClass = CSS.sidebarPanels; // TODO plus panelsClasses
    if (this.props.rdxSidebarActiveKey) panelsClass += " " + CSS.sidebarPanelsVisible;
    if (this.props.rdxSidebarPanelsExpanded) panelsClass += " " + CSS.expanded;
    if (this.props.rdxSidebarActiveKey === "events") panelsClass += " i-events-on";

    let explorePanel = null;
    if (this.useExploreCIM()) {
      explorePanel = (<ExploreCIM sidebarKey="explore"/>);
    } else {
      explorePanel = (<Explore sidebarKey="explore"/>);
    }

    let directionsButton = null, directionsPanel = null;
    if (Context.getInstance().config.networkServiceUrl) {
      directionsButton = (
        <SidebarButton key="directions" sidebarKey="directions"
          caption={i18n.directions.caption} iconClassName="right-16-f" arialLabel={i18n.directions.arialLabel}/>
      );
      directionsPanel = (
        <SidebarPanel key="directions" sidebarKey="directions" keepAlive={true}
          ><Directions sidebarKey="directions"/></SidebarPanel>
      );
    }

    let eventsButton = null, eventsPanel = null;
    let aiim = Context.getInstance().aiim;
    let eventsDataset = aiim && aiim.datasets && aiim.datasets.events;
    if (eventsDataset && eventsDataset.url && eventsDataset.getSource()) {
      eventsButton = (
        <SidebarButton key="events" sidebarKey="events"
          caption={i18n.events.caption} arialLabel={i18n.events.arialLabel}
          iconClassName="calendar-16-f" liClassName="i-sidebar-button--events"/>
      );
      eventsPanel = (
        <SidebarPanel key="events" sidebarKey="events">
          <Events sidebarKey="events"/>
        </SidebarPanel>
      );
    }

    return (
      <div className={CSS.main} role="navigation">
        <div className={CSS.sidebarMenus}>
          <ul className={CSS.sidebarMenu}>
            <SidebarButton key="explore" sidebarKey="explore"
              caption={i18n.explore.caption} iconClassName="globe-16-f" arialLabel={i18n.explore.arialLabel}/>
            <SidebarButton key="myPlaces" sidebarKey="myPlaces"
              caption={i18n.yourPlaces.caption} arialLabel={i18n.yourPlaces.arialLabel}
              iconClassName="pin-16-f" liClassName="i-non-kiosk-only"/>
            {directionsButton}
            {eventsButton}
          </ul>
          <ul className={CSS.sidebarMenu2}>
            <SidebarButton2 key="about" tooltip={i18n.about.caption}
              iconClassName="information-16-f"
              clickHandler={this.showAbout}
            />
          </ul>
        </div>
        <div className={panelsClass}>
          <SidebarPanel key="explore" sidebarKey="explore" keepAlive={true}
            >{explorePanel}</SidebarPanel>
          <SidebarPanel key="myPlaces"sidebarKey="myPlaces"
            ><MyPlaces sidebarKey="myPlaces"/></SidebarPanel>
          {directionsPanel}
          {eventsPanel}
        </div>
      </div>
    );
  }

  showAbout(event) {
    Topic.publish(Topic.ShowModal,{content: <About />});
  }

  useExploreCIM() {
    const aiim = Context.instance.aiim;
    return aiim && aiim.useCIMCategories();
  }

}

const mapStateToProps = (state) => {
  return {
    rdxSidebarActiveKey: Rdx.getValue(state,Rdx.Keys.SIDEBAR_ACTIVE_KEY),
    rdxSidebarPanelsExpanded: Rdx.getValue(state,Rdx.Keys.SIDEBAR_PANELS_EXPANDED)
  }
}

export default connect(mapStateToProps)(Sidebar);
